import { isEmpty } from "@helpers/helpers";

export const FloorsState = {
    show: false,
    options: [
        {value: '-1', label: 'زیرزمین', checked: false},
        {value: '0', label: 'همکف', checked: false},
        {value: '1', label: 'طبقه 1', checked: false},
        {value: '2', label: 'طبقه 2', checked: false},
        {value: '3', label: 'طبقه 3', checked: false},
        {value: '4', label: 'طبقه 4', checked: false},
        {value: '5', label: 'طبقه 5', checked: false},
        {value: '6', label: 'طبقه 5+', checked: false},
    ],
    selected_items: [],
};

export const getFloorNames = (floor = '') => {
    let floors = new Set();

    if (!isEmpty(floor)) {
        const handleFloor = (number) => {
            return (number === '0') ? 'همکف' : ((number === '-3') ? 'همه' : ((number === '-1') ? 'زیرزمین' : number));
        };

        if (typeof floor === "string") {
            floors.add(handleFloor(floor));
        } else if (typeof floor === "object" && floor.length) {
            for (let floor_num of floor) {
                floors.add(handleFloor(floor_num));
            }
        }
    }

    return [...floors];
};

